import SmartTip from './SmartTip';

export default SmartTip;
